module.exports = __webpack_public_path__ + "static/preview-shoutcart-c879ebcb7b7fd59afcc315417908a2a4.png";